import { render, staticRenderFns } from "./RedlightAccusationRisk.vue?vue&type=template&id=4def49a6&"
import script from "./RedlightAccusationRisk.vue?vue&type=script&lang=js&"
export * from "./RedlightAccusationRisk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports